module.exports = __webpack_public_path__ + "img/title-parlons-fourrage@2x.d212d896.jpg";